<template>
    <div class="m-grid__item m-grid__item--fluid m-wrapper">
        <div class="m-subheader ">
            <div class="d-flex align-items-center">
                <div class="mr-auto">
                    <h3 class="m-subheader__title m-subheader__title--separator">
                        Trail Terrain
                    </h3>
                    <ul class="m-subheader__breadcrumbs m-nav m-nav--inline">
                        <li class="m-nav__item m-nav__item--home">
                            <router-link exact :to="{ name: 'home' }" class="m-nav__link m-nav__link--icon">
                                <i class="m-nav__link-icon la la-home"></i>
                            </router-link>
                        </li>
                        <li class="m-nav__separator">
                            -
                        </li>
                        <li class="m-nav__item">
                            <router-link exact :to="{ name : 'terrain' }" class="m-nav__link"><span
                                    class="m-nav__link-text">Terrain</span>
                            </router-link>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="m-content">
            <div class="m-portlet m-portlet--mobile">
                <div class="m-portlet__head">
                    <div class="m-portlet__head-caption">
                        <div class="m-portlet__head-title">
                            <h3 class="m-portlet__head-text">
                                Terrains table
                                <small>
                                    List of all terrain
                                </small>
                            </h3>
                        </div>
                    </div>
                    <div class="m-portlet__head-tools">
                    </div>
                </div>
                <div class="m-portlet__body">
                    <!--begin: Search Form -->
                    <div class="m-form m-form--label-align-right m--margin-top-20 m--margin-bottom-30">
                        <div class="row align-items-center">
                            <div class="col-xl-8 order-2 order-xl-1">
                                <div class="form-group m-form__group row align-items-center">
                                    <div class="col-md-4">
                                        <div class="m-input-icon m-input-icon--left">
                                            <input type="text" class="form-control m-input m-input--solid"
                                                   v-model="search"
                                                   placeholder="Search..." id="generalSearch">
                                            <span class="m-input-icon__icon m-input-icon__icon--left">
                                                <span>
                                                    <i class="la la-search"></i>
                                                </span>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xl-4 order-1 order-xl-2 m--align-right">
                                <button v-b-modal="'terrainModal'"
                                        class="btn btn-brand m-btn m-btn--custom m-btn--icon m-btn--air m-btn--pill">
                                    <span>
                                        <i class="la la-plus"></i>
                                        <span>New terrain</span>
                                    </span>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="alert alert-success alert-dismissible" role="alert" v-if="alertCreated">
                        <button type="button" class="close" aria-label="Close" @click="alertCreated=false"></button>
                        New terrain created successfully
                    </div>
                    <div class="alert alert-success alert-dismissible" role="alert" v-if="alertUpdated">
                        <button type="button" class="close" aria-label="Close" @click="alertUpdated=false"></button>
                        Terrain updated successfully
                    </div>
                    <!--end: Search Form -->
                    <div class="table-responsive">
                    <table class="table table-inverse" v-if="terrains.length > 0">
                        <thead>
                        <tr>
                            <th>#</th>
                            <th>Name</th>
                            <th>Icon</th>
                            <th>Is Show</th>
                            <th>Actions</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="terrain,index in filteredTerrains" :key="index">
                            <td>{{index + 1}}</td>
                            <td>{{ terrain.name }}</td>
                            <td>
                                <gallery-preview
                                        v-bind:gallery="JSON.parse(terrain.icon)"
                                />
                            </td>
                            <td>
                                <span
                                    class="m-badge m-badge--wide"
                                    v-bind:class="[
                                        terrain.is_hide ? 'm-badge--danger' : 'm-badge--success',
                                    ]"
                                    >{{ terrain.is_hide ? "No" : "Yes" }}
                                </span>
                            </td>
                            <td style="width: 100px;">
                                <button title="Edit details"
                                        class="btn m-btn m-btn--hover-brand m-btn--icon m-btn--icon-only m-btn--pill"
                                        v-b-modal="'terrainModal'"
                                        @click="updateTerrain(terrain.id)">
                                    <i class="la la-edit"></i>
                                </button>
                                <button title="Delete" @click="deleteItem(terrain.id)"
                                        class="btn m-btn m-btn--hover-danger m-btn--icon m-btn--icon-only m-btn--pill">
                                    <i class="la la-trash"></i>
                                </button>
                                <button :title="terrain.is_hide ? 'Show terrain' : 'Hide terrain'"
                                    class="btn m-btn m-btn--hover-brand m-btn--icon m-btn--icon-only m-btn--pill"
                                    @click="hideTerrain(terrain)"
                                >
                                    <i class="la" :class="{'la-eye-slash': !terrain.is_hide, 'la-eye': terrain.is_hide}"></i>
                                </button>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                    </div>
                    <b-pagination v-if="total > 0 && total > pageSize" align="right" size="md" :total-rows="total"
                                  v-model="page" :per-page="pageSize">
                    </b-pagination>
                </div>

            </div>
            <terrain-modal @clear-id="clearId"
                            @clicked-reload="getList"
                            @show-create-success-alert="showCreateSuccessAlert"
                            @show-update-success-alert="showUpdateSuccessAlert"
                            v-bind:terrainId="terrainId"
            />
        </div>
    </div>
</template>

<script>
    import TerrainApi from '../../api/terrain';
    import TerrainModal from './TerrainModal'
    import GalleryPreview from "../property/PropertyPreview";

    export default {
        components: {
            TerrainModal,
            GalleryPreview
        },
        name: "terrain",
        data() {
            return {
                error: false,
                alertCreated: false,
                alertUpdated: false,
                message: null,
                page: 1,
                total: 0,
                search: '',
                pageSize: 15,
                terrainId: null,
                terrains: [],
                createdAlert: "New terrain created successfully",
                updatedAlert: "Terrain updated successfully"
            }
        },
        computed: {
            filteredTerrains: function () {
                return this.terrains.filter((terrain) => {
                    if (terrain.name.match(this.search)) {
                        return terrain;
                    }
                });
            }
        },
        watch: {
            page(val) {
                this.getList()
            },
            pageSize(val) {
                this.getList()
            }
        },
        beforeMount() {
            this.getList()
        },
        methods: {
            updateTerrain(id) {
                this.terrainId = id;
                this.$bvModal.show('terrainModal');
            },
            getList() {
                TerrainApi.getTerrain(this, {
                    page: this.page,
                    pageSize: this.pageSize
                }, (context) => {
                })
            },
            updatePageSize(val) {
                this.pageSize = parseInt(val);
            },
            clearId() {
                this.terrainId = null;
                this.getList();
            },
            showCreateSuccessAlert() {
                this.alertCreated = true;
                this.alertUpdated = false;
            },
            showUpdateSuccessAlert() {
                this.alertCreated = false;
                this.alertUpdated = true;
            },
            deleteItem(id) {
                let approve = confirm(`Do you want to remove this terrain?`);
                if (approve !== false) {
                    TerrainApi.removeTerrain(this, id, (context) => {
                        this.getList();
                        this.alertCreated = false;
                        this.alertUpdated = false;
                    });
                }
            },
            hideTerrain(terrain) {
                let msg = terrain.is_hide ? 'Do you want to show this terrain?' : 'Do you want to hide this terrain?';
                let approve = confirm(msg);
                if (approve !== false) {
                    TerrainApi.hideTerrain(this, terrain.id, (context) => {
                        this.page = 1;
                        this.getList();
                    });
                }
            }
        }
    }
</script>

<style scoped>

</style>